import React, { useEffect } from 'react';
import { CatalogList } from '../CatalogList';
import URL from '@/finsight/Router/urlConstants';
import { useCatalogIssuersContext } from '@/finsight/application/Catalog/Issuers/IssuersCatalogContext';

const Issuers = () => {
  const { issuersList, isFetching, reset } = useCatalogIssuersContext();

  useEffect(() => () => reset(), []);

  return (
    <CatalogList
      isFetching={ isFetching }
      data={ issuersList }
      catalogUrl={ URL.ISSUER }
      bodyHeight={ 740 }
    />
  );
};

export default Issuers;
